// ═══ 검차 리포트 도메인 → ARB 키 매핑 (신고 371 §9) ═══
// 앱 lib/features/eval/models/eval_damage_l10n.dart 이식 — 값(부위 key·손상 코드)은 서버 damage_data
// 정합으로 그대로 두고 **표시 라벨만** 웹 locale 키로 옮긴다. 신규 문구 0(키는 ARB 이식분).
// 판정 규칙의 정본은 서버 리포트 routes/eval-photos.js renderReportPage.

// 차체 zone partKey → locale 키 (레거시 top-view 키 포함).
var PART_KEY = {
  hood: 'evalPartHood', roof: 'evalPartRoof', trunk_top: 'evalPartTrunk', trunk: 'evalPartTrunk',
  fender_fl: 'evalPartFenderFl', fender_fl_s: 'evalPartFenderFl',
  fender_fr: 'evalPartFenderFr', fender_fr_s: 'evalPartFenderFr',
  door_fl: 'evalPartDoorFl', door_fl_s: 'evalPartDoorFl',
  door_fr: 'evalPartDoorFr', door_fr_s: 'evalPartDoorFr',
  door_rl: 'evalPartDoorRl', door_rl_s: 'evalPartDoorRl',
  door_rr: 'evalPartDoorRr', door_rr_s: 'evalPartDoorRr',
  quarter_l: 'evalPartQuarterL', quarter_l_s: 'evalPartQuarterL',
  quarter_r: 'evalPartQuarterR', quarter_r_s: 'evalPartQuarterR',
  a_pillar_l: 'evalPartAPillar', a_pillar_r: 'evalPartAPillar',
  b_pillar_l: 'evalPartBPillar', b_pillar_r: 'evalPartBPillar',
  c_pillar_l: 'evalPartCPillar', c_pillar_r: 'evalPartCPillar',
  side_sill_l: 'evalPartSideSill', side_sill_r: 'evalPartSideSill',
  radiator_sup: 'evalPartRadiatorSupport', front_panel: 'evalPartFrontPanel',
  inside_panel_l: 'evalPartInsidePanelL', inside_panel_r: 'evalPartInsidePanelR',
  sidemember_lf: 'evalPartSideMemberLf', sidemember_rf: 'evalPartSideMemberRf',
  sidemember_lr: 'evalPartSideMemberLr', sidemember_rr: 'evalPartSideMemberRr',
  wheelhouse_lf: 'evalPartWheelhouseLf', wheelhouse_rf: 'evalPartWheelhouseRf',
  wheelhouse_lr: 'evalPartWheelhouseLr', wheelhouse_rr: 'evalPartWheelhouseRr',
  cross_member: 'evalPartCrossMember', dash_panel: 'evalPartDashPanel',
  floor_front: 'evalPartFloorPanel', trunk_floor: 'evalPartTrunkFloor', rear_panel: 'evalPartRearPanel'
};

// 도막 컬럼(paint_*) → locale 키 (앱 evalPaintPartLabel 패리티 — 후드는 '본넷').
var PAINT_KEY = {
  paint_hood: 'evalPartBonnet', paint_roof: 'evalPartRoof', paint_trunk: 'evalPartTrunk',
  paint_fender_l: 'evalPartFenderL', paint_fender_r: 'evalPartFenderR',
  paint_door_fl: 'evalPartDoorFl', paint_door_fr: 'evalPartDoorFr',
  paint_door_rl: 'evalPartDoorRl', paint_door_rr: 'evalPartDoorRr',
  paint_quarter_l: 'evalPartQuarterL', paint_quarter_r: 'evalPartQuarterR'
};

// 손상 코드 → locale 키. 과거 xx/pp/f/w/m · 현재 X/P/Q/A/C.
var DAMAGE_TYPE_KEY = {
  xx: 'evalDamageTypeExchange', pp: 'evalDamageTypePaintRepair', f: 'evalDamageTypeBend',
  w: 'evalDamageTypeWeld', m: 'evalDamageTypeAdjust',
  X: 'evalDamageTypeNeedExchange', P: 'evalDamageTypeNeedPaint', Q: 'evalDamageTypeNeedSheetMetal',
  A: 'evalDamageTypeScratch', C: 'evalDamageTypeCorrosion'
};

// vehicle_flags → locale 키 (5종).
var FLAG_KEY = {
  splice: 'evalFlagSplice', top_swap: 'evalFlagTopSwap', flood: 'evalFlagFlood',
  two_tone_paint: 'evalFlagTwoTonePaint', full_repaint: 'evalFlagFullRepaint'
};

// 도면 패널 key → locale 키.
var VIEW_KEY = { left: 'evalViewLeft', top: 'evalViewTop', bottom: 'evalViewBottom', right: 'evalViewRight' };

export function partLabel(t, key) { return PART_KEY[key] ? t(PART_KEY[key]) : key; }
export function paintPartLabel(t, key) { return PAINT_KEY[key] ? t(PAINT_KEY[key]) : key; }
export function damageTypeLabel(t, code) { return DAMAGE_TYPE_KEY[code] ? t(DAMAGE_TYPE_KEY[code]) : code; }
export function flagLabel(t, flag) { return FLAG_KEY[flag] ? t(FLAG_KEY[flag]) : flag; }
export function viewLabel(t, key) { return VIEW_KEY[key] ? t(VIEW_KEY[key]) : ''; }

// damage_data 방어 — 서버가 파싱해 객체로 주지만 파싱 실패 시 원본 문자열이 그대로 온다.
export function parseDamage(raw) {
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) { return {}; }
  }
  return typeof raw === 'object' ? raw : {};
}

// 도막 3분기(신고 352) — NULL/''/미지정 = 미측정(null) · 0 = 정상 판정 · >0 = 실측 µm.
export function paintValue(result, col) {
  var raw = result ? result[col] : null;
  if (raw === null || raw === undefined || raw === '') return null;
  var n = Number(raw);
  return isNaN(n) ? null : n;
}

export { PART_KEY, PAINT_KEY, DAMAGE_TYPE_KEY, FLAG_KEY, VIEW_KEY };
